import httpbaseURL from "../common/axios";

class Commonservices {
  ChangePassword(ObjaVAl) {
    debugger;
    return httpbaseURL.httpMSUserManageMentUrl.post(
      "/Password/ChangePassword",
      ObjaVAl
    );
  }
}
export default new Commonservices();
